export default __webpack_public_path__ + "static/media/TopL_LightBlue.65360f2f.png";